import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_engagement_fye_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    engagement_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fye_year_start: fromDatatype.IntegerDatatypeInterface;
    fye_month_start: fromDatatype.IntegerDatatypeInterface;
    fye_year_end: fromDatatype.IntegerDatatypeInterface;
    fye_month_end: fromDatatype.IntegerDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_engagement_fye_hdr_RowClass implements bl_aat_engagement_fye_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    engagement_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fye_year_start: fromDatatype.IntegerDatatypeInterface;
    fye_month_start: fromDatatype.IntegerDatatypeInterface;
    fye_year_end: fromDatatype.IntegerDatatypeInterface;
    fye_month_end: fromDatatype.IntegerDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}
